module.exports = __webpack_public_path__ + "static/66import-5f2bbfa3044464bd45c026c8607ac5b6.png";